export var SessionRestartType = /*#__PURE__*/ function(SessionRestartType) {
    /** For restarts corresponding to playback failure. */ SessionRestartType[SessionRestartType["VPF_RETRY"] = 0] = "VPF_RETRY";
    /** For non-error conditions, such as restarting the session to apply a new bitrate cap. */ SessionRestartType[SessionRestartType["RESTART"] = 1] = "RESTART";
    return SessionRestartType;
}({});
export var SessionRestartStatus = /*#__PURE__*/ function(SessionRestartStatus) {
    /** No active restart in progress. */ SessionRestartStatus[SessionRestartStatus["IDLE"] = 0] = "IDLE";
    /** An error-related restart is in progress. */ SessionRestartStatus[SessionRestartStatus["VPF_RETRYING"] = 1] = "VPF_RETRYING";
    /** A non-error related restart is in progress. */ SessionRestartStatus[SessionRestartStatus["RESTARTING"] = 2] = "RESTARTING";
    return SessionRestartStatus;
}({});

//# sourceMappingURL=session-restart-controller.enums.js.map